import comp from "./RelatedConceptItem";
export default comp;
